import { Component, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { MobileLinksDTO } from '@signature-it/ngx-generic/models';
import { GenericConfig } from '@signature-it/ngx-generic/config';
import { INavbarMenuTop } from "./navbar-top.interface";

declare let _: any;

@Component({
    selector: 'main-header-navbar-mobile-top',
    templateUrl: './navbar-mobile-top.html',
    styleUrls: ['./navbar-mobile-top.scss'],
    standalone: false
})
export class MainHeaderNavbarMobileTopComponentGeneric {
    public readonly ATTR_TOP = "top";
    public readonly ATTR_ABOVE_TOP = "above-top";
    public readonly ATTR_BELOW_TOP = "below-top";
    public readonly ATTR_LOGO = "logo";
    public readonly ATTR_LOGO_COLLAPSED = "logo-collapsed";
    public readonly ATTR_LOGO_EXPANDED = "logo-expanded";

    @Input() data: INavbarMenuTop;
    @Input('is-sidebar-open') isOpen: boolean = false;
    @Output() toggle = new EventEmitter();

    isDam: boolean = GenericConfig.isDam ? true : false;

    constructor() {}

    get top(): MobileLinksDTO[] {
        return this.data.top || [];
    }

    get aboveTop(): MobileLinksDTO[] {
        return this.data.aboveTop || [];
    }

    get belowTop(): MobileLinksDTO[] {
        return this.data.belowTop || [];
    }

    get logo(): any {
        return this.data.logo || {};
    }

    get account(): MobileLinksDTO[] {
        return this.data.account || [];
    }

    sidebarToggle() {
        this.toggle.next(true);
    }

}
